import { render, staticRenderFns } from "./KnFormGroups.vue?vue&type=template&id=dd577680"
import script from "./KnFormGroups.js?vue&type=script&lang=js&external"
export * from "./KnFormGroups.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports